var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2975 0.93988H1.69805C0.75918 0.93988 0 1.61512 0 2.44997V20.3787C0 21.2135 0.75918 21.8929 1.69805 21.8929H21.2975C22.2363 21.8929 23 21.2135 23 20.3828V2.44997C23 1.61512 22.2363 0.93988 21.2975 0.93988ZM6.82363 18.7949H3.40957V8.79315H6.82363V18.7949ZM5.1166 7.43039C4.02051 7.43039 3.13555 6.62419 3.13555 5.62974C3.13555 4.6353 4.02051 3.8291 5.1166 3.8291C6.2082 3.8291 7.09316 4.6353 7.09316 5.62974C7.09316 6.6201 6.2082 7.43039 5.1166 7.43039ZM19.5994 18.7949H16.1898V13.9332C16.1898 12.775 16.1674 11.2813 14.4154 11.2813C12.641 11.2813 12.3715 12.5459 12.3715 13.8513V18.7949H8.96641V8.79315H12.2367V10.16H12.2816C12.7354 9.37427 13.8494 8.54352 15.507 8.54352C18.9615 8.54352 19.5994 10.6143 19.5994 13.307V18.7949Z",
    fill: "#09218D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.e8a2eb4dfaf478190af334648ebd0042.svg";
export { ForwardRef as ReactComponent };